import { memo, ComponentProps } from 'react'
import { Avatar, Badge } from '@mui/material'
import Picture from 'components/Picture'
import Link from 'components/Link'
import { makeStyles } from 'tss-react/mui'

interface IPersonAvatarProps extends ComponentProps<typeof Avatar> {
  url?: string
  href?: string | null
  width?: number
  badgeContent?: any
  badgeProps?: any
  dotProps?: any
  dotColor?: any
  icon?: any
}

const useStyles = makeStyles()(theme => ({
  badge: {
    /* need this to undo the effect of badge > span if there are multiple badges */
    boxShadow: 'none !important',
    '& > span': {
      boxShadow: `0 0 0 2px ${'#FFF'}`,
    },
  },
}))

function PersonAvatar(props: IPersonAvatarProps) {
  const { classes } = useStyles()
  const { url, href = '', width = 100, icon, badgeContent, badgeProps = {}, dotProps = {}, dotColor, ...otherProps } = props

  let element

  if (url) {
    element = (
      <Avatar {...otherProps}>
        <Picture width={width} src={url} style={{ width: '100%', display: 'block' }} />
      </Avatar>
    )
  } else if (icon) {
    element = (
      <Avatar {...otherProps}>
        {icon}
      </Avatar>
    )
  } else {
    element = (
      <Avatar {...otherProps}>
        <Picture
          src="https://flexhire-images.s3.amazonaws.com/images/no_avatar.png"
          srcFallback="https://flexhire-images.s3.amazonaws.com/images/no_avatar.png"
          style={{ width: '100%', display: 'block' }}
        />
      </Avatar>
    )
  }

  if (dotColor) {
    element = (
      <Badge
        variant="dot"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        overlap="circular"
        color={dotColor}
        className={classes.badge}
        {...dotProps}
      >
        {element}
      </Badge>
    )
  }

  if (badgeContent) {
    element = (
      <Badge
        badgeContent={badgeContent}
        overlap="circular"
        className={classes.badge}
        {...badgeProps}
      >
        {element}
      </Badge>
    )
  }

  if (href) {
    return <Link href={href} style={{ textDecoration: 'none' }}>{element}</Link>
  }

  return element
}

export default memo(PersonAvatar)
